import './Footer.css'

const Footer = () => {
  return (
    <div className="container-footer">
      <p>Direitos reservados a Sheylla Barbosa Rodacki Nunes</p>
      {/* <p>Desenvolvido por Francisco de Souza Sancho</p> */}
    </div>
  )
}

export default Footer
